import type { HTMLAttributes } from "react";

export default function BottomDropdownIcon(
  props: HTMLAttributes<HTMLDivElement>
) {
  return (
    <div {...props}>
      <svg
        width="10"
        height="5"
        viewBox="0 0 10 5"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.08203 0.75L4.91536 4.08333L0.748696 0.749999"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
}
